export default {

    companyName : "螳螂号科技",
    wechat:"yc-0831",
    email:"1552612373@qq.com",
    telephone:"15011160206"
}


// WEBPACK FOOTER //
// ./src/config.js